const styles = ({ palette, components }) => ({
  bigAvatar: {
    borderRadius: 4,
    display: 'none',
    fontSize: 38,
    height: 64,
    width: 64,
    '@media (min-width: 800px)': {
      display: 'flex',
    },
  },
  body: {
    backgroundColor: palette.greyScaleDeprecated[7],
    padding: '25px 25px',
  },
  boldTypography: {
    fontWeight: 500,
  },
  chip: {
    backgroundColor: components.scheduledTxns.chip,
  },
  defaultOverride: {
    color: palette.greyScaleDeprecated[0],
    cursor: 'default',
    borderBottom: `0.5px solid ${palette.greyScaleDeprecated[5]}`,
    '& .Mui-disabled': {
      '-webkit-text-fill-color': palette.greyScaleDeprecated[0],
    },
  },
  ellipsedText: {
    maxWidth: 300,
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  ellipsedWrapText: {
    maxWidth: 200,
  },
  header: {
    backgroundColor: palette.greyScaleDeprecated[5],
    padding: 25,
  },
  headerSpace: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
  },
  nextDate: {
    marginTop: 18,
  },
  positiveAmount: {
    color: 'green',
  },
  underlineOverride: {
    '&:before': {
      borderBottom: `1px solid ${palette.greyScaleDeprecated[5]}`,
    },
  },
  closeButton: {
    padding: 0,
  },
  deleteButton: {
    width: 36,
    minWidth: 36,
    marginLeft: 8,
  },
});

export default styles;
